module.exports = __webpack_public_path__ + "img/proyecto10.6c426af4.png";